import api from '../api/axios.config';

export const inventoryHealthService = {
  getFilerOptions: async (period) => {
    try {
      const params = {};

      if (period) params.period = period;

      const response = await api.get(`/inventory-health/filter-options`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getTableData: async (page, view_type, branch, period, page_size, columnFilters = {}) => {
    try {
      const params = {};

      if (branch) params.branch = branch;
      if (page) params.page = page;
      if (page_size) params.page_size = page_size;
      if (view_type) params.view_type = view_type;
      if (period) params.period = period;

      Object.entries(columnFilters).forEach(([key, values]) => {
        if (values?.length) params[key] = values;
      });

      const response = await api.get(`/inventory-health`, { params });
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  getCategoryA: async (view_type, branch_name, period) => {
    try {
      const params = {};

      if (branch_name) params.branch_name = branch_name;
      if (view_type) params.view_type = view_type;
      if (period) params.period = period;

      const response = await api.get(`/inventory-health/category-a`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getCategoryB: async (view_type, branch_name, period) => {
    try {
      const params = {};

      if (branch_name) params.branch_name = branch_name;
      if (view_type) params.view_type = view_type;
      if (period) params.period = period;

      const response = await api.get(`/inventory-health/category-b`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getCategoryC: async (view_type, branch_name, period) => {
    try {
      const params = {};

      if (branch_name) params.branch_name = branch_name;
      if (view_type) params.view_type = view_type;
      if (period) params.period = period;

      const response = await api.get(`/inventory-health/category-c`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getOverstock: async (view_type, branch_name, period, top_n) => {
    try {
      const params = {};

      if (branch_name) params.branch_name = branch_name;
      if (view_type) params.view_type = view_type;
      if (period) params.period = period;
      if (top_n) params.top_n = top_n;

      const response = await api.get(`/inventory-health/overstock`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getUnderstock: async (view_type, branch_name, period, top_n) => {
    try {
      const params = {};

      if (branch_name) params.branch_name = branch_name;
      if (view_type) params.view_type = view_type;
      if (period) params.period = period;
      if (top_n) params.top_n = top_n;

      const response = await api.get(`/inventory-health/understock`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getOutofStock: async (view_type, branch_name, period, top_n) => {
    try {
      const params = {};

      if (branch_name) params.branch_name = branch_name;
      if (view_type) params.view_type = view_type;
      if (period) params.period = period;
      if (top_n) params.top_n = top_n;

      const response = await api.get(`/inventory-health/out-of-stock`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getHealthInfo: async () => {
    try {

      const response = await api.get(`/inventory-health/health-index-information-icon`);
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  getHealthDeviationInfo: async () => {
    try {
      const response = await api.get(`/inventory-health/health-index-deviation-information-icon`);
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },
};
